import AdaptiveImage from "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "e38e780f59dc6818f7ae97d9a9fef9f5.png",
    width: 1667,
    height: 2342
});